<template>
    <div class="lms__superadmin_users_bulk_actions">
        <div class="lms__superadmin_users_bulk_actions_header">
            <view-actions
                :title="'Bulk actions'"
                :custom-notify-active="false"
                :cancel-button-text="'Cancel'"
                :cancel-notify-active="false"
                :submit-button-active="true"
                :submit-button-text="'Next'"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Users',
                        to: backToUsers
                    }
                ]"
                @emit-cancel="stopAddUsers"
                @emit-submit="performGoNext"
            />
        </div>
        <div class="lms__superadmin_users_bulk_actions_main">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <template v-if="loggedInWorkspaceId">
                            <form-radio
                                :label="''"
                                :name="'lms-superadmin-users-bulk-actions-add-users-to-group'"
                                :items="[
                                    {
                                        name: 'Add users to group',
                                        value: 'add-users-to-group'
                                    }
                                ]"
                                v-model="bulkActionName"
                            >Add a selection of users to a group or a set of groups.
                            </form-radio>
                            <form-radio
                                :label="''"
                                :name="'lms-superadmin-users-bulk-actions-remove-users-from-group'"
                                :items="[
                                    {
                                        name: 'Remove users from group',
                                        value: 'remove-users-from-group'
                                    }
                                ]"
                                v-model="bulkActionName"
                            >Remove a selection of users from a group or a set of groups.
                            </form-radio>
                            <component-separator></component-separator>
                            <form-radio
                                :label="''"
                                :name="'lms-superadmin-users-bulk-actions-delete-profiles'"
                                :items="[
                                    {
                                        name: 'Archive profiles',
                                        value: 'delete-profiles'
                                    }
                                ]"
                                v-model="bulkActionName"
                            >Remove a users access from this workspace.
                            </form-radio>
                            <form-radio
                                :label="''"
                                :name="'lms-superadmin-users-bulk-actions-reactivate-profiles'"
                                :items="[
                                    {
                                        name: 'Reactivate profiles',
                                        value: 'reactivate-profiles'
                                    }
                                ]"
                                v-model="bulkActionName"
                            >Give archived users the right to access this workspace again.
                            </form-radio>
                            <component-separator></component-separator>
                            <form-radio
                                :label="''"
                                :name="'lms-superadmin-users-bulk-actions-resend-invitations'"
                                :items="[
                                {
                                    name: 'Resend invitations',
                                    value: 'resend-invitations'
                                }
                            ]"
                                v-model="bulkActionName"
                            >Re-send invitations to those who have been invited.
                            </form-radio>
                            <form-radio
                                :label="''"
                                :name="'lms-superadmin-users-bulk-actions-cancel-invitations'"
                                :items="[
                                {
                                    name: 'Cancel invitations',
                                    value: 'cancel-invitations'
                                }
                            ]"
                                v-model="bulkActionName"
                            >Cancel and withdraw a bunch of invitations.
                            </form-radio>
                            <component-separator></component-separator>
                        </template>
                        <form-radio
                            :label="''"
                            :name="'lms-superadmin-users-bulk-actions-invite-users'"
                            :items="[
                                {
                                    name: 'Invite users',
                                    value: 'invite-users'
                                }
                            ]"
                            v-model="bulkActionName"
                        >Invite a number of learners to Form.
                        </form-radio>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import FormRadio from '@/components/default/forms/FormRadio'
import EmailtemplateListGrid from '@/components/ebs/emails/list/EmailsListGrid'
import ComponentSeparator from '@/components/default/shared/ComponentSeparator'

export default {
  name: 'lms-superadmin-users-bulk-actions',
  data () {
    return {
      bulkActionName: 'add-users-to-group'
    }
  },
  components: { ComponentSeparator, EmailtemplateListGrid, FormRadio, ViewActions },
  computed: {
    loggedInWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    backToUsers () {
      return { name: 'lms-superadmin-user-list' }
    }
  },
  methods: {
    stopAddUsers () {
      this.$router.push({ name: 'lms-superadmin-user-list' })
    },
    performGoNext () {
      if (this.bulkActionName === 'add-users-to-group') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-add-to-groups' })
      } else if (this.bulkActionName === 'remove-users-from-group') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-remove-from-groups' })
      } else if (this.bulkActionName === 'delete-profiles') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-delete-profiles' })
      } else if (this.bulkActionName === 'reactivate-profiles') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-reactivate-profiles' })
      } else if (this.bulkActionName === 'resend-invitations') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-resend-invitations' })
      } else if (this.bulkActionName === 'cancel-invitations') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-cancel-invitations' })
      } else if (this.bulkActionName === 'invite-users') {
        this.$router.push({ name: 'lms-superadmin-user-bulk-add' })
      }
    }
  },
  mounted () {
    if (this.loggedInWorkspaceId) {
      this.bulkActionName = 'add-users-to-group'
    } else {
      this.bulkActionName = 'invite-users'
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactions.scss";
</style>
